const checkIsHeadingInHash = (hash, heading) => {
  const lowercaseDashesHeading = heading?.replace(/\s+/g, '-')?.toLowerCase();

  return hash?.includes(lowercaseDashesHeading);
};

export default checkIsHeadingInHash;
